import React from 'react'

import { AuthService } from './auth.types'

export const authContext = React.createContext<null | AuthService>(null)
